import lsApi from "../api/lsApi";
import { IEncuesta, IListEncuesta, IResultadoRow } from '../models/encuestas';
import { useAppSelector } from '../redux/hooks';

interface GuardarEncuestaRequest {
    id_Encuesta: number;
    casa: number;
    respuestas: string;
}

interface GuardarEncuestaResponse {
    success: boolean;
    message: string;
}

export function useEncuestas() {

    const userData = useAppSelector((state) => state.auth.userData);

    const getListEncuestas = async (): Promise<IListEncuesta[]> => {
        try {
            const casa = userData?.casa ?? 0;
            const { data, status } = await lsApi.get<IListEncuesta[]>(`/api/ControlAcceso/ListadoEncuestas?casa=${casa}`);
            return status === 200 ? data : [];
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    const getDetalleEncuesta = async (encuestaId: number): Promise<IEncuesta[]> => {
        try {
            const { data, status } = await lsApi.get<IEncuesta[]>(`/api/ControlAcceso/DetalleEncuesta?INFORMULARIO=${encuestaId}`);
            return status === 200 ? data : [];
        } catch (err) {
            console.error(err);
            return [];
        }
    };

    const saveEncuesta = async (idEncuesta: number, respuestasXml: string): Promise<GuardarEncuestaResponse> => {
        try {
            const request: GuardarEncuestaRequest = {
                id_Encuesta: idEncuesta,
                casa: userData?.casa ?? 0,
                respuestas: respuestasXml,
            };
            const { data } = await lsApi.post<GuardarEncuestaResponse>('/api/ControlAcceso/GuardarEncuesta', request);
            return data;
        } catch (error) {
            console.error(error);
            return { success: false, message: 'Error de conexion.' };
        }
    };

    const getResultadosEncuesta = async (formulario: number): Promise<IResultadoRow[]> => {
        try {
            const { data, status } = await lsApi.get<IResultadoRow[]>(`/api/ControlAcceso/ResultadosEncuesta?formulario=${formulario}`);
            return status === 200 ? data : [];
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    return { getListEncuestas, getDetalleEncuesta, saveEncuesta, getResultadosEncuesta };
}
